export default () => {


    $('.js-view-booking-details').on('click', function (e) {
        e.preventDefault();
        viewBookingDetails();
    });

    if ($('.js-searchoptions').length) {
        $('.js-searchoptions').on('change', function () {
            var selected = this.value;
            $('.js-selected-option-field').hide();
            $('*[data-selected-option="' + selected + '"]').show();
        });
    }

    function search_bookings() {
        $('.js-trackingresults').addClass('loading');
        $('.js-searchresults').find('.js-results').html('');
        $('.js-trackingdetails').find('.js-results').html('');

        var search_option = $('.js-searchoptions').val();
        if (search_option == 'daterange') {
            if (checkSearchFieldNotEmpty(search_option)) {
                $('.js-results').html('');
                var data = {
                    fromDate: $('.js-fromDate').val(),
                    toDate: $('.js-toDate').val()
                };
                callSearchBookingAjax(data);
            } else {
                showValidationMessage();
            }
        } else {
            if (checkSearchFieldNotEmpty(search_option)) {
                $('.js-results').html('');
                var data = {
                    bkgNo: $('.js-searchBookingNumber').val()
                };
                callSearchBookingAjax(data);
            } else {
                showValidationMessage();
            }
        }
    }

    function show_booking_details(BookingNumber) {
        if (BookingNumber) {
            $('.js-trackingresults').addClass('loading');
            $.ajax({
                type: "POST",
                url: get_url_path('/getBookingDetails'),
                data: {
                    bkgNo: BookingNumber
                },
                success: function (response) {
                    $('.js-trackingresults').removeClass('loading');
                    $('.js-results').html(response);
                }
            });
        }
    }

    function viewBookingDetails() {
        $('.js-trackingresults').addClass('loading');
        var searchOption = $('.js-searchoptions').val();
        $('.js-results').html('');
        if (checkSearchFieldNotEmpty(searchOption)) {
            var data = {
                [searchOption]: $('*[data-selected-option="' + [searchOption] + '"]').find('input').val().toUpperCase()
            };
            $.ajax({
                type: "POST",
                url: get_url_path('/viewBooking/viewBookingDetails'),
                data: data,
                success: function (response) {
                    $('.js-trackingresults').removeClass('loading');
                    $('.js-results').html(response);
                    $('.js-showBookingDetails').on('click', function (ev) {
                        ev.preventDefault();
                        show_booking_details($(this).data('booknum'));
                    });
                }
            });
        } else {
            showValidationMessage();
        }

    }

    function checkSearchFieldNotEmpty(selectedOption) {
        var valid = true
        var inputVals = $('*[data-selected-option="' + selectedOption + '"]').find('input');
        inputVals.each(function () {
            var element = $(this);
            if (element.val() == "") {
                valid = false;
            }
        });
        return valid;
    }

    function showValidationMessage() {
        $('.js-trackingresults').removeClass('loading');
        $('.js-results').html("Please enter search criteria");
        return;
    }

    function callSearchBookingAjax(data) {
        $.ajax({
            type: "POST",
            url: get_url_path('/searchBookings'),
            data: data,
            success: function (response) {
                $('.js-trackingresults').removeClass('loading');
                $('.js-results').html(response);
            }
        });
    }


    function get_url_path(append) {
        var append = append ? append : '';
        var home = (window.location.pathname == '' || window.location.pathname == '/') ? '/home' : '';
        return window.location.pathname.replace(/\/$/, '') + home + append;
    };
}
